<web-payments-list-tab
  [company]="data.company"
  [detailOnlyMode]="true"
  [autoOpenPaymentIntentId]="data.paymentIntentId"
  [reservationId]="data.reservationId"
  [seedOrderNumber]="data.orderNumber"
  [seedShopName]="data.shopName"
  (detailClosed)="onDetailClosed()"
  (paymentChanged)="onPaymentChanged($event)"
></web-payments-list-tab>
